// TODO: The icons are here because this is an experimental feature that may be removed.
import FifthIcon from '@assets/images/icons/export/fifth-icon.svg?react'
import FirstIcon from '@assets/images/icons/export/first-icon.svg?react'
import FourthIcon from '@assets/images/icons/export/fourth-icon.svg?react'
import SecondIcon from '@assets/images/icons/export/second-icon.svg?react'
import ThirdIcon from '@assets/images/icons/export/third-icon.svg?react'
import type React from 'react'

import { clsJoin } from '@/utils'
import css from './styles.module.css'

export const Logos: React.FC = () => (
  <div className={css.logos}>
    <div className={css.logos_icon_wrap}>
      <FirstIcon />
    </div>
    <div className={clsJoin(css.logos_icon_wrap, css.second)}>
      <SecondIcon />
    </div>
    <div className={clsJoin(css.logos_icon_wrap, css.third)}>
      <ThirdIcon />
    </div>
    <div className={clsJoin(css.logos_icon_wrap, css.fourth)}>
      <FourthIcon />
    </div>
    <div className={clsJoin(css.logos_icon_wrap, css.fifth)}>
      <FifthIcon />
    </div>
  </div>
)
